import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestData({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'presets', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteData({ payload }) {
  try {
    const { id, params } = payload;

    yield call(api.delete, `presets/${id}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.post, 'presets', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/presets');
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `presets/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'presets', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/presets');
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'presets', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest('@preset/DATA_IN_REQUEST', requestData),
  takeLatest('@preset/DELETE_DATA', deleteData),
  takeLatest('@preset/SUCCESS_REMOVE', requestData),
  takeLatest('@preset/STORE_DATA', store),
  takeLatest('@preset/FIND_DATA', find),
  takeLatest('@preset/UPDATE_DATA', update),
  takeLatest('@preset/RECORD_FILTERING', applyedFilters),
]);
